import { render, staticRenderFns } from "./mdFace.vue?vue&type=template&id=bb844dd0&scoped=true&"
import script from "./mdFace.vue?vue&type=script&lang=js&"
export * from "./mdFace.vue?vue&type=script&lang=js&"
import style0 from "./mdFace.vue?vue&type=style&index=0&id=bb844dd0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb844dd0",
  null
  
)

export default component.exports